(function () {
  const node = document.getElementById('meta-welcome-gift-config');
  if (!node || window.metaWelcomeGift) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const variantId = Number(config.variantId);
  if (!Number.isSafeInteger(variantId) || variantId < 1) return;
  let eligible = config.landing || config.eligible;
  let queue = Promise.resolve();
  let timer;
  let allowCheckout = false;
  let currentState = 'ready';
  const isGift = (item) => Number(item.variant_id || item.id) === variantId && item.properties?._gwp === 'true';
  const isOwned = (item) => isGift(item) && item.properties?._meta_welcome === 'v1';
  const hasPurchase = (cart) => cart.items.some((item) => item.properties?._gwp !== 'true' && Number(item.final_line_price) > 0);

  async function request(url, body) {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Gift request failed');
    return data;
  }

  function setStatus(state) {
    currentState = state;
    document.querySelectorAll('[data-meta-gift-status]').forEach((element) => {
      element.textContent = config.messages[state];
      element.dataset.state = state;
    });
  }

  function activate() {
    document.documentElement.classList.add('meta-gift-active');
    if (document.querySelector('[data-meta-gift-status]')) return;
    const main = document.querySelector('main');
    if (!main) return;
    const notice = document.createElement('div');
    notice.className = 'meta-gift-notice';
    notice.dataset.metaGiftStatus = '';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    main.prepend(notice);
    setStatus(currentState);
  }

  function sections() {
    const list = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'].map((id) => ({ id, element: document.getElementById(id) }));
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const sectionId = document.querySelector(`#${id}[data-id]`)?.dataset.id;
      if (sectionId) list.push({ id: sectionId, element: document.getElementById(`shopify-section-${sectionId}`) });
    });
    return list.filter((section) => section.element);
  }

  function render(data, targets) {
    targets.forEach((target) => {
      const html = data.sections?.[target.id];
      if (!html) return;
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      const element = document.getElementById(target.element.id) || target.element;
      if (content) element.innerHTML = content.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { metaGift: true } }));
  }

  async function reconcile(refresh) {
    let cart = await request(config.cartUrl);
    eligible = eligible || cart.attributes?._meta_welcome === 'v1';
    if (!eligible) return true;
    activate();
    if (cart.attributes?._meta_welcome !== 'v1') {
      cart = await request(config.updateUrl, { attributes: { _meta_welcome: 'v1' } });
    }
    const targets = refresh ? sections() : [];
    const sectionData = targets.length ? { sections: targets.map((target) => target.id), sections_url: window.location.pathname } : {};
    const gifts = cart.items.filter(isGift);
    const owned = gifts.filter(isOwned);
    let changed = false;
    if (!hasPurchase(cart)) {
      if (owned.length) {
        cart = await request(config.updateUrl, { updates: Object.fromEntries(owned.map((item) => [item.key, 0])), ...sectionData });
        if (refresh) render(cart, targets);
      }
      setStatus(config.available ? 'ready' : 'unavailable');
      return true;
    }
    if (!gifts.length) {
      if (!config.available) { setStatus('unavailable'); return false; }
      setStatus('pending');
      await request(config.addUrl, { items: [{ id: variantId, quantity: 1, properties: { _gwp: 'true', _meta_welcome: 'v1' } }] });
      cart = await request(config.cartUrl);
      changed = true;
    }
    const currentGifts = cart.items.filter(isGift);
    const keeper = currentGifts.find((item) => !isOwned(item)) || currentGifts[0];
    const updates = {};
    currentGifts.filter(isOwned).forEach((item) => {
      const quantity = item.key === keeper?.key ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) {
      cart = await request(config.updateUrl, { updates });
      changed = true;
    }
    const freeGift = cart.items.find((item) => isGift(item) && item.quantity === 1 && item.final_line_price === 0);
    if (!freeGift) {
      const paidOwned = cart.items.filter(isOwned);
      if (paidOwned.length) {
        cart = await request(config.updateUrl, { updates: Object.fromEntries(paidOwned.map((item) => [item.key, 0])), ...sectionData });
        if (refresh) render(cart, targets);
      }
      setStatus('unavailable');
      return false;
    }
    if (refresh && changed && targets.length) {
      const response = await request(config.updateUrl, { attributes: { _meta_welcome: 'v1' }, ...sectionData });
      render(response, targets);
    }
    setStatus('added');
    return true;
  }

  function sync(refresh = true) {
    const run = () => reconcile(refresh).catch((error) => {
      if (eligible) setStatus('unavailable');
      console.warn('[meta-welcome-gift]', error);
      return false;
    });
    queue = queue.then(() => window.navigator.locks ? window.navigator.locks.request('url-gift-auto-add', run) : run());
    return queue;
  }

  function schedule(event) {
    if (event?.detail?.metaGift || event?.detail?.gwpAutoAdd) return;
    clearTimeout(timer);
    timer = setTimeout(() => sync(), 80);
  }

  window.metaWelcomeGift = { sync };
  if (eligible) { activate(); sync(); }
  ['cart:updated', 'cart:refresh', 'ajaxProduct:added', 'cartdrawer:opened'].forEach((name) => document.addEventListener(name, schedule));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  window.addEventListener('pageshow', (event) => { if (event.persisted) sync(); });
  window.addEventListener('focus', () => sync());
  document.addEventListener('submit', async (event) => {
    if (!eligible || allowCheckout) return;
    const form = event.target;
    const returnTo = form.elements?.namedItem('return_to')?.value;
    const formUrl = new URL(form.action || config.cartUrl, window.location.href);
    const directAdd = /\/cart\/add\/?$/.test(formUrl.pathname) && returnTo && /\/checkout\/?$/.test(new URL(returnTo, window.location.href).pathname);
    if (!directAdd && event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset?.metaGiftSubmitting === 'true') return;
    clearTimeout(timer);
    const button = event.submitter;
    if (form.dataset) form.dataset.metaGiftSubmitting = 'true';
    button?.setAttribute('aria-busy', 'true');
    try {
      if (directAdd) {
        const data = new FormData(form);
        data.delete('return_to');
        const response = await fetch(config.addUrl, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add product');
        const ready = await sync(false);
        window.location.assign(ready ? returnTo : config.cartUrl.replace(/\.js$/, ''));
        return;
      }
      if (await sync(false)) {
        allowCheckout = true;
        form.requestSubmit(button);
        allowCheckout = false;
      } else document.querySelector('[data-meta-gift-status]')?.scrollIntoView({ block: 'center' });
    } catch (error) {
      setStatus('unavailable');
      const message = form.querySelector('.product-form__error-message') || document.querySelector('[data-meta-gift-status]');
      if (message) message.textContent = error.message;
    } finally {
      button?.removeAttribute('aria-busy');
      if (form.dataset) delete form.dataset.metaGiftSubmitting;
    }
  }, true);
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[href]');
    if (!eligible || !link) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || !/\/checkout\/?$/.test(destination.pathname)) return;
    event.preventDefault();
    if (await sync(false)) window.location.assign(destination.href);
  }, true);
})();
